export default "__VITE_ASSET__fef705bc__"